import { SearchIcon } from '@chakra-ui/icons'
import {
  HStack,
  Avatar,
  Heading,
  VStack,
  Text,
  Box,
  Icon,
  IconButton,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Spinner
} from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { BsPencil } from 'react-icons/bs'
import { FiSave } from 'react-icons/fi'
import moment from 'moment'
import { Layout, Loader, SettingBox } from '../../components'
import { ControlledInput, Input } from '../../components/form'
import useSettingsStore from '../../state/Settings.store'
import { sleep } from '../../utils/sleep'
import { titleCase } from '../../utils'
import { PHONE } from '../../utils/validations'

const Profile = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  // const [loading, setLoading] = useState(false)
  const [user, loading, getSettings, updatePhone, updateloading] = useSettingsStore((state) => [
    state.user,
    state.loading,
    state.getSettings,
    state.updatePhone,
    state.updateloading
  ])

  useEffect(() => {
    getSettings()
  }, [getSettings])

  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields, isValid },
    watch,
    control
  } = useForm({
    mode: 'onChange',
    defaultValues: { phone: user?.phone_number }
  })
  const onSubmit = async (data: any) => {
    try {
      await updatePhone(data.phone)
      onClose()
    } catch (error) {
      console.log('error')
    }
  }

  return (
    <Layout title="User Profile">
      {/* <Loader text="Saving Changes..." loading={loading} /> */}
      {loading === 'loading' ? (
        <VStack h="100vh" justify="center" flex={1}>
          <Spinner size="xl" />
        </VStack>
      ) : loading === 'success' ? (
        <>
          <HStack mb="1.6rem" spacing="1.6rem">
            <Avatar size="xl" name={`${user.first_name} ${user.last_name} ${user.middle_name}`} />
            <VStack align="flex-start">
              <Heading color="black" fontSize="1.4rem">
                {titleCase(`${user.first_name} ${user.last_name} ${user.middle_name}`)}
              </Heading>
              <Text color="#4D80E4" fontSize="1.1rem">
                {user.email}
              </Text>
            </VStack>
          </HStack>
          <VStack flex={1} spacing={0} w="full">
            <Box
              spacing="2rem"
              borderTop="1px solid #e2e1e1"
              as={HStack}
              justifyContent="space-between"
              w="full"
              alignItems="center">
              <Box py="1.4rem" spacing="2rem" as={HStack} alignItems="center">
                <svg
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.366 8.182C7.30434 9.83048 8.66952 11.1957 10.318 12.134L11.202 10.896C11.3442 10.6969 11.5543 10.5569 11.7928 10.5023C12.0313 10.4478 12.2814 10.4825 12.496 10.6C13.9103 11.3729 15.4722 11.8378 17.079 11.964C17.3298 11.9839 17.5638 12.0975 17.7345 12.2823C17.9052 12.4671 18 12.7094 18 12.961V17.423C18.0001 17.6706 17.9083 17.9094 17.7424 18.0932C17.5765 18.277 17.3483 18.3927 17.102 18.418C16.572 18.473 16.038 18.5 15.5 18.5C6.94 18.5 0 11.56 0 3C0 2.462 0.027 1.928 0.082 1.398C0.107255 1.1517 0.222984 0.923521 0.40679 0.757634C0.590595 0.591747 0.829406 0.499947 1.077 0.5H5.539C5.79056 0.499968 6.0329 0.594752 6.21768 0.765451C6.40247 0.93615 6.51613 1.17022 6.536 1.421C6.66222 3.02779 7.12708 4.58968 7.9 6.004C8.01746 6.21856 8.05221 6.46874 7.99767 6.7072C7.94312 6.94565 7.80306 7.15584 7.604 7.298L6.366 8.182ZM3.844 7.525L5.744 6.168C5.20478 5.00409 4.83535 3.76884 4.647 2.5H2.01C2.004 2.666 2.001 2.833 2.001 3C2 10.456 8.044 16.5 15.5 16.5C15.667 16.5 15.834 16.497 16 16.49V13.853C14.7312 13.6646 13.4959 13.2952 12.332 12.756L10.975 14.656C10.4287 14.4437 9.89801 14.1931 9.387 13.906L9.329 13.873C7.36758 12.7567 5.74328 11.1324 4.627 9.171L4.594 9.113C4.30691 8.60199 4.05628 8.07134 3.844 7.525Z"
                    fill="#4D80E4"
                  />
                </svg>
                <VStack spacing="0.5rem" align="flex-start">
                  <Text fontSize="1rem">Telephone</Text>
                  <Heading fontWeight="500" color="black" fontSize="1.2rem">
                    {user.phone_number}
                  </Heading>
                </VStack>
              </Box>
              <IconButton
                h="full"
                onClick={onOpen}
                borderRadius={0}
                bg="rgba(70, 179, 230, 0.05)"
                aria-label="Search database"
                icon={<Icon w="6.8rem" h="1.9rem" as={BsPencil} />}
              />
            </Box>

            {Options.map((item) => (
              <SettingBox
                description={
                  item.key === 'dob'
                    ? moment(user[item.key]).format('DD-MMM-YYYY')
                    : item.key === 'gender'
                    ? user[item.key].startsWith('M')
                      ? 'Male'
                      : 'Female'
                    : user[item.key]
                }
                {...item}
              />
            ))}
          </VStack>

          <Modal onClose={onClose} isOpen={isOpen}>
            <ModalOverlay />
            <ModalContent
              mt="auto"
              rounded="12px"
              px="1rem"
              maxW={{ md: '480px !important' }}
              mx="auto">
              <ModalHeader mb="1rem" fontWeight="500" mt="1.2rem" fontSize="1.4rem" color="black">
                Edit Phone Number
              </ModalHeader>
              <ModalBody>
                <HStack
                  spacing="1rem"
                  align="flex-start"
                  as="form"
                  onSubmit={handleSubmit(onSubmit)}>
                  <Controller
                    control={control}
                    rules={PHONE}
                    name="phone"
                    render={({ field }) => (
                      <ControlledInput
                        isValid={watch('phone') && !errors.phone && true}
                        isError={errors.phone && errors.phone.message}
                        type="number"
                        flex={1}
                        label="Telephone"
                        id="phone"
                        inputMode="numeric"
                        value={field.value}
                        onChange={(e) => {
                          if (e.target.value.length > 11) {
                            e.preventDefault()
                            return
                          }
                          field.onChange(e)
                        }}
                      />
                    )}
                  />

                  <IconButton
                    isLoading={updateloading}
                    type="submit"
                    isDisabled={!isValid}
                    colorScheme="blue"
                    h="5.6rem"
                    w="5.8rem"
                    aria-label="Search database"
                    bg="brand.blue"
                    icon={<Icon w="4.8rem" h="2.5rem" as={FiSave} />}
                  />
                </HStack>
              </ModalBody>
            </ModalContent>
          </Modal>
        </>
      ) : null}
    </Layout>
  )
}

export { Profile }

const Options = [
  {
    title: 'Date of Birth',
    key: 'dob',
    icon: (
      <svg
        width="22"
        height="23"
        viewBox="0 0 22 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 7.50034V11.5003H19C19.2652 11.5003 19.5196 11.6057 19.7071 11.7932C19.8946 11.9808 20 12.2351 20 12.5003V20.5003H22V22.5003H0V20.5003H2V12.5003C2 12.2351 2.10536 11.9808 2.29289 11.7932C2.48043 11.6057 2.73478 11.5003 3 11.5003H10V7.50034H12ZM18 13.5003H4V20.5003H18V13.5003ZM12.83 0.902344C13.2278 1.59138 13.3356 2.41022 13.1297 3.17874C12.9238 3.94726 12.421 4.60251 11.732 5.00034L10 6.00034C9.60219 5.31131 9.49439 4.49247 9.7003 3.72395C9.90622 2.95543 10.409 2.30018 11.098 1.90234L12.83 0.902344Z"
          fill="#4D80E4"
        />
      </svg>
    )
  },
  {
    title: 'BVN',
    key: 'bvn',
    icon: (
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13 14.5V13.5H10V10.5H13V12.5H15V14.5H14V16.5H12V18.5H10V15.5H12V14.5H13ZM18 18.5H14V16.5H16V14.5H18V18.5ZM0 0.5H8V8.5H0V0.5ZM2 2.5V6.5H6V2.5H2ZM10 0.5H18V8.5H10V0.5ZM12 2.5V6.5H16V2.5H12ZM0 10.5H8V18.5H0V10.5ZM2 12.5V16.5H6V12.5H2ZM15 10.5H18V12.5H15V10.5ZM3 3.5H5V5.5H3V3.5ZM3 13.5H5V15.5H3V13.5ZM13 3.5H15V5.5H13V3.5Z"
          fill="#4D80E4"
        />
      </svg>
    )
  },
  {
    title: 'Gender',
    key: 'gender',
    icon: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.99986 14C9.80208 14 9.60874 14.0587 9.44429 14.1685C9.27984 14.2784 9.15167 14.4346 9.07598 14.6173C9.00029 14.8 8.98049 15.0011 9.01907 15.1951C9.05766 15.3891 9.1529 15.5673 9.29275 15.7071C9.4326 15.847 9.61079 15.9422 9.80477 15.9808C9.99875 16.0194 10.1998 15.9996 10.3825 15.9239C10.5653 15.8482 10.7214 15.72 10.8313 15.5556C10.9412 15.3911 10.9999 15.1978 10.9999 15C10.9999 14.7348 10.8945 14.4804 10.707 14.2929C10.5194 14.1054 10.2651 14 9.99986 14ZM9.99986 0.500002C9.81228 0.499996 9.62482 0.509509 9.43821 0.528502C6.83934 0.673126 4.39944 1.82602 2.63754 3.74194C0.875643 5.65786 -0.0692173 8.1856 0.00395376 10.7875C0.0771248 13.3893 1.16255 15.86 3.02935 17.6738C4.89614 19.4877 7.39697 20.5017 9.99986 20.5C10.1874 20.5 10.3749 20.4905 10.5615 20.4715C13.1604 20.3269 15.6003 19.174 17.3622 17.2581C19.1241 15.3421 20.0689 12.8144 19.9958 10.2125C19.9226 7.61068 18.8372 5.14003 16.9704 3.32616C15.1036 1.51229 12.6027 0.498339 9.99986 0.500002ZM9.99986 18.5C8.37567 18.5023 6.78938 18.0094 5.45244 17.0872C4.11549 16.1649 3.09141 14.857 2.5167 13.3379C1.94199 11.8188 1.84396 10.1606 2.23568 8.58439C2.62739 7.00815 3.49024 5.58874 4.70921 4.51538C4.47667 5.3326 4.43721 6.19268 4.59394 7.02776C4.75066 7.86284 5.09929 8.65008 5.61232 9.32737C6.12535 10.0047 6.78874 10.5535 7.55016 10.9305C8.31159 11.3076 9.1502 11.5025 9.99986 11.5C10.9281 11.5 11.8184 11.8688 12.4747 12.5251C13.1311 13.1815 13.4999 14.0717 13.4999 15C13.4999 15.9283 13.1311 16.8185 12.4747 17.4749C11.8184 18.1313 10.9281 18.5 9.99986 18.5ZM15.2905 16.4846C15.523 15.6674 15.5625 14.8073 15.4058 13.9722C15.2491 13.1372 14.9004 12.3499 14.3874 11.6726C13.8744 10.9953 13.211 10.4465 12.4496 10.0695C11.6881 9.69244 10.8495 9.49749 9.99986 9.5C9.0716 9.5 8.18136 9.13125 7.52499 8.47488C6.86861 7.8185 6.49986 6.92826 6.49986 6C6.49986 5.07174 6.86861 4.18151 7.52499 3.52513C8.18136 2.86875 9.0716 2.5 9.99986 2.5C11.624 2.49774 13.2103 2.99059 14.5473 3.91285C15.8842 4.8351 16.9083 6.14296 17.483 7.66207C18.0577 9.18118 18.1558 10.8394 17.764 12.4156C17.3723 13.9919 16.5095 15.4113 15.2905 16.4846ZM9.99986 5C9.80208 5 9.60874 5.05865 9.44429 5.16853C9.27984 5.27841 9.15167 5.43459 9.07598 5.61732C9.00029 5.80004 8.98049 6.00111 9.01907 6.19509C9.05766 6.38907 9.1529 6.56726 9.29275 6.70711C9.4326 6.84696 9.61079 6.9422 9.80477 6.98079C9.99875 7.01937 10.1998 6.99957 10.3825 6.92388C10.5653 6.84819 10.7214 6.72002 10.8313 6.55557C10.9412 6.39112 10.9999 6.19778 10.9999 6C10.9999 5.73479 10.8945 5.48043 10.707 5.2929C10.5194 5.10536 10.2651 5 9.99986 5Z"
          fill="#4D80E4"
        />
      </svg>
    )
  }
]
